import { Route } from "@angular/router"
import { WorkshopListComponent } from "./ui/workshop-list/workshop-list.component"

const workshopRoutes: Route[] = [
    {
      path: 'workshops',
      children: [
        {
          path: '',
          component: WorkshopListComponent
        }
      ]
    }
  ]
  
  export default workshopRoutes